import { QUERY_SIGNED_DOCUMENT } from "../../query/signedDocuments/keys";
import { QUERY_SHARED_FILE } from "../../query/sharedFile/keys";
import { QUERY_BACKGROUND_CHECKS_REQUEST } from "../../query/backgroundChecks/queries/useBackgroundChecksRequestQuery";
import { QUERY_IDENTITY_VERIFICATION_REQUEST } from "../../query/identityVerification/keys";
import { QUERY_INSURANCE_COVERAGE_MONITOR } from "../../query/insuranceCoverageMonitor/queries/useInsuranceCoverageMonitorQuery";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "../../query/notifications/keys";
import {
  QUERY_REQUIREMENT,
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE
} from "../../query/requirements/keys";
import { QUERY_PAYER_ROWS_ALL } from "../../query/search/payer/queries/useQueryPayerRowsAll";
import { QUERY_ALL_PAYEE_ROWS } from "../../query/search/payee/queries/useQueryAllPayeeRows";
import { QUERY_PAYER_ENGAGEMENT } from "../../query/payerEngagements/keys";
import { QUERY_ALL_ENGAGEMENTS_BY_PAYER_IDS } from "../Onboarding/queries/useQueryAllPayersWithEngagements";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL
} from "../../query/payeeEngagements/keys";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../query/resourceEvents/queries/useQueryListEvents";
import { QUERY_INSURANCE_COVERAGES } from "../../query/insuranceCoverage/queries/useInsuranceCoverages";

export const REQUIREMENTS_DEPENDENCIES = [
  QUERY_SIGNED_DOCUMENT,
  QUERY_SHARED_FILE,
  QUERY_BACKGROUND_CHECKS_REQUEST,
  QUERY_IDENTITY_VERIFICATION_REQUEST,
  QUERY_INSURANCE_COVERAGE_MONITOR,
  QUERY_NOTIFICATIONS_NOTIFICATIONS,
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE,
  QUERY_REQUIREMENT,
  QUERY_PAYER_ROWS_ALL,
  QUERY_ALL_PAYEE_ROWS,
  QUERY_PAYER_ENGAGEMENT,
  QUERY_ALL_ENGAGEMENTS_BY_PAYER_IDS,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_LIST_RESOURCE_EVENTS,
  QUERY_INSURANCE_COVERAGES
];
